// extracted by mini-css-extract-plugin
module.exports = {"auction":"auction-module--auction--3Xz4l"};